// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form-overlay {
  position: absolute;
  inset: 0;
  background: var(--theme-overlay-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.contact-form {
  background: var(--theme-modal-bg);
  border: 1px solid var(--theme-modal-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--theme-shadow-strong);
  width: 440px;
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.contact-form__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-lg) var(--space-lg) var(--space-md);
  border-bottom: 1px solid var(--theme-border-primary);
}
.contact-form__header h2 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--theme-text-primary);
}
.contact-form__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-md);
  border: none;
  background: transparent;
  color: var(--theme-text-muted);
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.contact-form__close:hover {
  background: var(--theme-hover-neutral);
  color: var(--theme-text-primary);
}
.contact-form__body {
  flex: 1 1;
  overflow-y: auto;
  padding: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}
.contact-form__section {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  padding-bottom: var(--space-lg);
  border-bottom: 1px solid var(--theme-border-soft);
}
.contact-form__section:last-of-type {
  border-bottom: none;
}
.contact-form__section-label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--theme-text-muted);
}
.contact-form__row {
  display: flex;
  gap: var(--space-sm);
}
.contact-form__row .contact-form__field {
  flex: 1 1;
}
.contact-form__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.contact-form__field label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--theme-text-secondary);
}
.contact-form__field input,
.contact-form__field textarea {
  padding: 7px 10px;
  border-radius: var(--radius-md);
  border: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-secondary);
  color: var(--theme-text-primary);
  font-size: var(--font-size-md);
  outline: none;
  transition: border-color 0.12s, box-shadow 0.12s, background 0.12s;
}
.contact-form__field input::placeholder,
.contact-form__field textarea::placeholder {
  color: var(--theme-text-placeholder);
}
.contact-form__field input:focus,
.contact-form__field textarea:focus {
  border-color: var(--theme-border-focus);
  background: var(--theme-bg-primary);
  box-shadow: var(--theme-shadow-focus);
}
.contact-form__field textarea {
  resize: vertical;
  font-family: inherit;
  line-height: 1.5;
}
.contact-form__tiers {
  display: flex;
  flex-direction: row;
  gap: var(--space-xs);
}
.contact-form__tier-option {
  flex: 1 1;
  padding: 8px var(--space-sm);
  border-radius: var(--radius-md);
  border: 1px solid var(--theme-border-primary);
  background: transparent;
  cursor: pointer;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--theme-text-secondary);
  text-align: center;
  transition: all 0.12s;
}
.contact-form__tier-option:hover {
  background: var(--theme-hover-neutral);
  color: var(--theme-text-primary);
}
.contact-form__tier-option--active.contact-form__tier-option--close {
  background: var(--theme-primary-soft);
  border-color: var(--theme-primary);
  color: var(--theme-primary-text);
}
.contact-form__tier-option--active.contact-form__tier-option--regular {
  background: #ecfdf5;
  background: var(--theme-success-bg, #ecfdf5);
  border-color: var(--theme-success);
  color: var(--theme-success);
}
.contact-form__tier-option--active.contact-form__tier-option--archived {
  background: var(--theme-bg-tertiary);
  border-color: var(--theme-border-strong);
  color: var(--theme-text-secondary);
}
.contact-form__error {
  margin: 0;
  padding: var(--space-sm) var(--space-md);
  background: #fef2f2;
  background: var(--theme-danger-bg, #fef2f2);
  color: var(--theme-danger);
  border-radius: var(--radius-md);
  font-size: var(--font-size-md);
}
.contact-form__footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-sm);
  padding-top: var(--space-sm);
}
.contact-form__btn {
  padding: 7px var(--space-lg);
  border-radius: var(--radius-md);
  border: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-primary);
  color: var(--theme-text-primary);
  font-size: var(--font-size-md);
  cursor: pointer;
  transition: background 0.12s, transform 0.12s, box-shadow 0.12s;
}
.contact-form__btn:hover:not(:disabled) {
  background: var(--theme-hover-neutral);
}
.contact-form__btn--primary {
  background: var(--theme-primary);
  color: var(--theme-primary-contrast);
  border-color: var(--theme-primary);
  box-shadow: var(--theme-shadow-subtle);
}
.contact-form__btn--primary:hover:not(:disabled) {
  background: var(--theme-primary-hover);
  border-color: var(--theme-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--theme-shadow-soft);
}
.contact-form__btn--primary:active {
  transform: translateY(0);
  box-shadow: var(--theme-shadow-subtle);
}
.contact-form__btn--primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}`, "",{"version":3,"sources":["webpack://./src/apps/ContactsApp/components/ContactForm/ContactForm.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kCAAA;UAAA,0BAAA;AACF;;AAEA;EACE,iCAAA;EACA,2CAAA;EACA,+BAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wDAAA;EACA,oDAAA;AACJ;AACI;EACE,SAAA;EACA,8BAAA;EACA,wCAAA;EACA,gCAAA;AACN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,yCAAA;AADJ;AAGI;EACE,sCAAA;EACA,gCAAA;AADN;AAKE;EACE,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,+BAAA;EACA,iDAAA;AAJJ;AAMI;EACE,mBAAA;AAJN;AAQE;EACE,8BAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AANJ;AASE;EACE,aAAA;EACA,oBAAA;AAPJ;AASI;EACE,SAAA;AAPN;AAWE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AATJ;AAWI;EACE,8BAAA;EACA,sCAAA;EACA,kCAAA;AATN;AAYI;;EAEE,iBAAA;EACA,+BAAA;EACA,6CAAA;EACA,qCAAA;EACA,gCAAA;EACA,8BAAA;EACA,aAAA;EACA,kEAAA;AAVN;AAYM;;EACE,oCAAA;AATR;AAYM;;EACE,uCAAA;EACA,mCAAA;EACA,qCAAA;AATR;AAaI;EACE,gBAAA;EACA,oBAAA;EACA,gBAAA;AAXN;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAdJ;AAiBE;EACE,SAAA;EACA,4BAAA;EACA,+BAAA;EACA,6CAAA;EACA,uBAAA;EACA,eAAA;EACA,8BAAA;EACA,sCAAA;EACA,kCAAA;EACA,kBAAA;EACA,qBAAA;AAfJ;AAiBI;EACE,sCAAA;EACA,gCAAA;AAfN;AAmBM;EACE,qCAAA;EACA,kCAAA;EACA,gCAAA;AAjBR;AAmBM;EACE,mBAAA;EAAA,4CAAA;EACA,kCAAA;EACA,2BAAA;AAjBR;AAmBM;EACE,oCAAA;EACA,wCAAA;EACA,kCAAA;AAjBR;AAsBE;EACE,SAAA;EACA,wCAAA;EACA,mBAAA;EAAA,2CAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;AApBJ;AAuBE;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;AArBJ;AAwBE;EACE,4BAAA;EACA,+BAAA;EACA,6CAAA;EACA,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,eAAA;EACA,+DAAA;AAtBJ;AAwBI;EACE,sCAAA;AAtBN;AAyBI;EACE,gCAAA;EACA,oCAAA;EACA,kCAAA;EACA,sCAAA;AAvBN;AAyBM;EACE,sCAAA;EACA,wCAAA;EACA,2BAAA;EACA,oCAAA;AAvBR;AA0BM;EACE,wBAAA;EACA,sCAAA;AAxBR;AA2BM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAzBR","sourcesContent":[".contact-form-overlay {\n  position: absolute;\n  inset: 0;\n  background: var(--theme-overlay-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  backdrop-filter: blur(4px);\n}\n\n.contact-form {\n  background: var(--theme-modal-bg);\n  border: 1px solid var(--theme-modal-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--theme-shadow-strong);\n  width: 440px;\n  max-width: 95vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space-lg) var(--space-lg) var(--space-md);\n    border-bottom: 1px solid var(--theme-border-primary);\n\n    h2 {\n      margin: 0;\n      font-size: var(--font-size-lg);\n      font-weight: var(--font-weight-semibold);\n      color: var(--theme-text-primary);\n    }\n  }\n\n  &__close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: var(--radius-md);\n    border: none;\n    background: transparent;\n    color: var(--theme-text-muted);\n    cursor: pointer;\n    transition: background 0.12s, color 0.12s;\n\n    &:hover {\n      background: var(--theme-hover-neutral);\n      color: var(--theme-text-primary);\n    }\n  }\n\n  &__body {\n    flex: 1;\n    overflow-y: auto;\n    padding: var(--space-lg);\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n    padding-bottom: var(--space-lg);\n    border-bottom: 1px solid var(--theme-border-soft);\n\n    &:last-of-type {\n      border-bottom: none;\n    }\n  }\n\n  &__section-label {\n    font-size: var(--font-size-xs);\n    font-weight: var(--font-weight-semibold);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--theme-text-muted);\n  }\n\n  &__row {\n    display: flex;\n    gap: var(--space-sm);\n\n    .contact-form__field {\n      flex: 1;\n    }\n  }\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    label {\n      font-size: var(--font-size-sm);\n      font-weight: var(--font-weight-medium);\n      color: var(--theme-text-secondary);\n    }\n\n    input,\n    textarea {\n      padding: 7px 10px;\n      border-radius: var(--radius-md);\n      border: 1px solid var(--theme-border-primary);\n      background: var(--theme-bg-secondary);\n      color: var(--theme-text-primary);\n      font-size: var(--font-size-md);\n      outline: none;\n      transition: border-color 0.12s, box-shadow 0.12s, background 0.12s;\n\n      &::placeholder {\n        color: var(--theme-text-placeholder);\n      }\n\n      &:focus {\n        border-color: var(--theme-border-focus);\n        background: var(--theme-bg-primary);\n        box-shadow: var(--theme-shadow-focus);\n      }\n    }\n\n    textarea {\n      resize: vertical;\n      font-family: inherit;\n      line-height: 1.5;\n    }\n  }\n\n  // Tier picker — horizontal compact buttons\n  &__tiers {\n    display: flex;\n    flex-direction: row;\n    gap: var(--space-xs);\n  }\n\n  &__tier-option {\n    flex: 1;\n    padding: 8px var(--space-sm);\n    border-radius: var(--radius-md);\n    border: 1px solid var(--theme-border-primary);\n    background: transparent;\n    cursor: pointer;\n    font-size: var(--font-size-md);\n    font-weight: var(--font-weight-medium);\n    color: var(--theme-text-secondary);\n    text-align: center;\n    transition: all 0.12s;\n\n    &:hover {\n      background: var(--theme-hover-neutral);\n      color: var(--theme-text-primary);\n    }\n\n    &--active {\n      &.contact-form__tier-option--close {\n        background: var(--theme-primary-soft);\n        border-color: var(--theme-primary);\n        color: var(--theme-primary-text);\n      }\n      &.contact-form__tier-option--regular {\n        background: var(--theme-success-bg, #ecfdf5);\n        border-color: var(--theme-success);\n        color: var(--theme-success);\n      }\n      &.contact-form__tier-option--archived {\n        background: var(--theme-bg-tertiary);\n        border-color: var(--theme-border-strong);\n        color: var(--theme-text-secondary);\n      }\n    }\n  }\n\n  &__error {\n    margin: 0;\n    padding: var(--space-sm) var(--space-md);\n    background: var(--theme-danger-bg, #fef2f2);\n    color: var(--theme-danger);\n    border-radius: var(--radius-md);\n    font-size: var(--font-size-md);\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: var(--space-sm);\n    padding-top: var(--space-sm);\n  }\n\n  &__btn {\n    padding: 7px var(--space-lg);\n    border-radius: var(--radius-md);\n    border: 1px solid var(--theme-border-primary);\n    background: var(--theme-bg-primary);\n    color: var(--theme-text-primary);\n    font-size: var(--font-size-md);\n    cursor: pointer;\n    transition: background 0.12s, transform 0.12s, box-shadow 0.12s;\n\n    &:hover:not(:disabled) {\n      background: var(--theme-hover-neutral);\n    }\n\n    &--primary {\n      background: var(--theme-primary);\n      color: var(--theme-primary-contrast);\n      border-color: var(--theme-primary);\n      box-shadow: var(--theme-shadow-subtle);\n\n      &:hover:not(:disabled) {\n        background: var(--theme-primary-hover);\n        border-color: var(--theme-primary-hover);\n        transform: translateY(-1px);\n        box-shadow: var(--theme-shadow-soft);\n      }\n\n      &:active {\n        transform: translateY(0);\n        box-shadow: var(--theme-shadow-subtle);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
